export const DEFAULT_GRID_SIZE = 0.635;
export const DEFAULT_TOOL_DIAMETER = 0.2;

const src: any = {}

type GlobalDrawContextParams = {
    gridSize: number,
    toolDiameter: number,
    zeroOffsetX: number,
    zeroOffsetY: number
}

export class GlobalContext {
    editorContext(): GlobalDrawContextParams {
        return this.gs("drawContext", this.editorDefaultContext()) as GlobalDrawContextParams
    }

    private editorDefaultContext(): GlobalDrawContextParams {
        return {
            gridSize: DEFAULT_GRID_SIZE,
            toolDiameter: DEFAULT_TOOL_DIAMETER,
            zeroOffsetX: 0.0,
            zeroOffsetY: 0.0
        }
    }

    private getOrCreate(name: string, defaultObject: any) {
        if (src[name] == null) {
            src[name] = defaultObject
        }
        return src[name]
    }

    private reset(name: string, defaultObject: any) {
        src[name] = defaultObject
    }

    private gs(contextName: string, defaultObject: any): any {
        return this.getOrCreate(
            contextName,
            defaultObject
        )
    }
}

export const globalContext: GlobalContext = new GlobalContext()